"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDefaultAndInputProps = exports.validateDurationInFrames = exports.validateDimension = exports.validateFps = void 0;
/* eslint-disable prefer-destructuring */
const no_react_1 = require("remotion/no-react");
exports.validateFps = no_react_1.NoReactInternals.validateFps;
exports.validateDimension = no_react_1.NoReactInternals.validateDimension;
exports.validateDurationInFrames = no_react_1.NoReactInternals.validateDurationInFrames;
exports.validateDefaultAndInputProps = no_react_1.NoReactInternals.validateDefaultAndInputProps;
